/**
 * @generated SignedSource<<b7dab2a4ff5133206d131e66dc0dd694>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingSource = "CUSTOMER" | "EVENT" | "GOLF_GENIUS" | "MEMBER" | "PACESETTER" | "STAFF" | "SUPREME" | "TOURNAMENT_MANAGEMENT";
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type MoveBookingButton_Booking$data = {
  readonly canUpdate: boolean | null | undefined;
  readonly id: string;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isPaid: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly paymentRequirements: {
    readonly prePaymentRequirement: PrePaymentRequirement;
  } | null | undefined;
  readonly source: BookingSource | null | undefined;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly date: string;
      readonly facility: {
        readonly id: string;
        readonly slug: string;
        readonly type: FacilityType;
      };
    };
    readonly course?: {
      readonly id: string;
    };
    readonly id: string;
    readonly isInCancelWindow?: boolean;
    readonly time?: string;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly type: BookingType;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldPresentBookingAsLockedRequest_booking">;
  readonly " $fragmentType": "MoveBookingButton_Booking";
};
export type MoveBookingButton_Booking$key = {
  readonly " $data"?: MoveBookingButton_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoveBookingButton_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoveBookingButton_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingPaymentRequirements",
      "kind": "LinkedField",
      "name": "paymentRequirements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prePaymentRequirement",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldPresentBookingAsLockedRequest_booking"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPaid",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isInCancelWindow",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "time",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "dff834ba8dc61130ea20c27e6a306577";

export default node;
